__webpack_require__.p = "/interactive/intel/forging-the-future-alongside-ai/";